import _ from 'lodash';

const SESSION_REDIRECT_PAGE_KEY = 'REDIRECT_PAGE';
const SESSION_REDIRECT_PARAMS_KEY = 'REDIRECT_PARAMS';
const SESSION_REDIRECT_QUERY_KEY = 'REDIRECT_QUERY';

// storage points to the current browser window's storage session.
const storage = window.sessionStorage;

// RedirectorsFetch fetches all the redirector information from session
// storage then clears the keys.
export const RedirectorsFetch = () => {
  const redirectPage = sessionStorage.getItem(SESSION_REDIRECT_PAGE_KEY);
  const redirectParams = sessionStorage.getItem(SESSION_REDIRECT_PARAMS_KEY);
  let redirectQuery = sessionStorage.getItem(SESSION_REDIRECT_QUERY_KEY);
  if (redirectQuery) redirectQuery = JSON.parse(redirectQuery);

  sessionStorage.removeItem(SESSION_REDIRECT_PAGE_KEY);
  sessionStorage.removeItem(SESSION_REDIRECT_PARAMS_KEY);
  sessionStorage.removeItem(SESSION_REDIRECT_QUERY_KEY);

  return { redirectPage, redirectParams, redirectQuery };
};

// RedirectorsSet stores the query from the redirectors into session storage.
export const RedirectorsSet = (routeQuery) => {
  const params = _.get(routeQuery, 'params');
  const redirect = _.get(routeQuery, 'redirect');

  if (redirect) sessionStorage.setItem(SESSION_REDIRECT_PAGE_KEY, redirect);
  if (params) sessionStorage.setItem(SESSION_REDIRECT_PARAMS_KEY, params);

  const queryNew = _.cloneDeep(routeQuery);
  delete queryNew.params;
  delete queryNew.redirect;
  sessionStorage.setItem(SESSION_REDIRECT_QUERY_KEY, JSON.stringify(queryNew));
};
